import { useMemo, useState } from "react";

import { LESSON_REQUEST_TYPES,TOPIC_CHIPS } from "constants/lessonRequest";

import dayjs from "dayjs";
import Calendar from "react-calendar";

const TOPIC_OTHER = "기타";

function SelectionChip({ active, label, sub, onClick }) {
    return (
        <div
            className={`btn selection-chip selection-chip--stacked ${active ? "btn-purple500" : "btn-outline-gray200"}`}
            onClick={onClick}
        >
            <span className="selection-chip__label">{label}</span>
            {sub && <span className="selection-chip__sub">{sub}</span>}
        </div>
    );
}

export default function Step2Schedule({
    requestType,
    meta,
    showsTicketSection,
    ticketItems,
    ticketId,
    setTicketId,
    trialItems,
    onSelectTrial,
    trialSportId,
    topic,
    setTopic,
    sessionTabs,
    dayOrder,
    setDayOrder,
    prerequisiteNotMet,
    prerequisiteMessage,
    selectedDate,
    setRequestedDate,
    visibleTimes,
    startTime,
    setStartTime,
}) {
    const isRegular = requestType === LESSON_REQUEST_TYPES.REGULAR;
    const isSpecial = requestType === LESSON_REQUEST_TYPES.SPECIAL;
    const isTrial = requestType === LESSON_REQUEST_TYPES.TRIAL;


    // --- PREMIUM "무엇을 연습하고 싶으신가요?" 기타(직접 입력) ---
    // topic이 칩 목록에 없으면(빈 값 제외) 기타 입력 상태로 본다.
    const topicMatchesChip = TOPIC_CHIPS.includes(topic);
    const [isCustomTopic, setIsCustomTopic] = useState(() => Boolean(topic) && !topicMatchesChip);

    // 시간 슬롯을 오전(00~11시)/오후(12~23시)로 나눠 시각적으로 구분한다.
    const timePeriods = useMemo(() => {
        const am = [];
        const pm = [];
        visibleTimes.forEach((time) => {
            const hour = Number(time.split(":")[0]);
            (hour < 12 ? am : pm).push(time);
        });
        return [
            { label: "오전", times: am },
            { label: "오후", times: pm },
        ].filter((period) => period.times.length > 0);
    }, [visibleTimes]);

    // 1차 선택 섹션 (요청 타입별로 다르게 노출)
    const renderPrimarySelection = () => {
        // 강습권/특강권 선택 (REGULAR with tickets, SPECIAL with tickets)
        if (showsTicketSection || ((isRegular || isSpecial) && ticketItems.length > 0)) {
            return (
                <section className="section-group">
                    <div className="section-group__header">
                        <h3>{isSpecial ? "사용할 스페셜 트레이닝권을 선택해주세요" : "사용할 강습권을 선택해주세요"}</h3>
                    </div>
                    <div className="class-ticket-wrap">
                        {ticketItems.map((item) => (
                            <SelectionChip
                                key={item.id}
                                active={String(ticketId) === String(item.id)}
                                label={item.label}
                                sub={item.sub}
                                onClick={() => setTicketId(String(item.id))}
                            />
                        ))}
                    </div>
                </section>
            );
        }

        // REGULAR는 사용자가 보유한 강습권으로만 요청할 수 있다.
        // no-ticket 상품 기반 유료 요청 경로는 제거되었고, 상위 페이지에서 구매 안내 화면으로 차단한다.
        if (isRegular) {
            return (
                <section className="section-group">
                    <div className="section-group__header">
                        <h3>사용할 강습권을 선택해주세요</h3>
                        <p>강습권 요청은 보유한 티켓으로만 신청할 수 있어요.</p>
                    </div>
                </section>
            );
        }

        // TRIAL: 체험 종목 칩(주제용). 실제 체험 상품은 브랜드 지정 상품으로 BE 가 resolve 한다.
        if (isTrial) {
            return (
                <section className="section-group">
                    <div className="section-group__header">
                        <h3>무엇을 배울까요?</h3>
                        <p>강사가 수락하면 결제 안내가 가고, 결제하면 예약이 확정돼요. 체험 상품은 홈 브랜드 설정에 따라 안내돼요.</p>
                    </div>

                    <div className="chip-grid">
                        {trialItems.map((item) => {
                            const active = String(trialSportId) === String(item.id);
                            return (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`btn btn-small btn-fit  ${active ? "btn-purple500" : "btn-outline-gray200"}`}
                                    onClick={() => onSelectTrial(item)}
                                >
                                    {item.label}
                                </button>
                            );
                        })}
                    </div>

                </section>
            );
        }

        // PREMIUM: 훈련 주제 선택. 종목(sport)은 홈 헤더의 preferred_sport 를 자동 사용하므로 선택 UI 가 없다.
        return (
            <section className="section-group">
                <div className="section-group__header">
                    <h3>무엇을 연습하고 싶으신가요?</h3>
                    <p>프리미엄 트레이닝은 유료이며 결제는 강사 수락 후 진행돼요.</p>
                </div>

                <div className="chip-grid">
                    {TOPIC_CHIPS.map((chip) => (
                        <button
                            key={chip}
                            type="button"
                            className={`btn  btn-small btn-fit  ${!isCustomTopic && topic === chip ? "btn-purple500" : "btn-outline-purple500"}`}
                            onClick={() => {
                                setIsCustomTopic(false);
                                setTopic((current) => (current === chip ? "" : chip));
                            }}
                        >
                            {chip}
                        </button>
                    ))}
                    <button
                        type="button"
                        className={`btn btn-outline-purple500 btn-small btn-fit  ${isCustomTopic ? "btn-purple500" : "btn-outline-purple500"}`}
                        onClick={() => {
                            setIsCustomTopic(true);
                            setTopic("");
                        }}
                    >
                        {TOPIC_OTHER}
                    </button>
                </div>
                {isCustomTopic && (
                    <input
                        className="lr-input"
                        style={{ marginTop: 12 }}
                        value={topic}
                        onChange={(event) => setTopic(event.target.value)}
                        placeholder="연습하고 싶은 내용을 입력해 주세요"
                    />
                )}

            </section>
        );
    };

    return (
        <div className="step-view">
            {renderPrimarySelection()}

            {isRegular && (
                <section className="section-group">
                    <div className="section-group__header">
                        <h3>들어야할 세션은 몇 강인가요?</h3>
                    </div>
                    <div className="chip-grid">
                        {sessionTabs.map((tab) => (
                            <button
                                key={tab.value}
                                type="button"
                                className={`btn btn-small btn-fit ${dayOrder === tab.value ? "btn-purple500" : "btn-outline-purple500"}`}
                                onClick={() => setDayOrder(tab.value)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                    {prerequisiteNotMet && (
                        <p className="lr-prereq-alert" role="alert">{prerequisiteMessage}</p>
                    )}
                </section>
            )}

            {isSpecial && (
                <section className="section-group">
                    <div className="section-group__header">
                        <h3>스페셜 트레이닝 주제 <span className="lr-optional">선택</span></h3>
                    </div>
                    <input
                        className="lr-input"
                        value={topic}
                        onChange={(event) => setTopic(event.target.value)}
                        placeholder="예) 이퀄라이징 교정, 딥탱크 24m (선택)"
                    />
                    <div className="chip-grid" style={{ marginTop: 12 }}>
                        {TOPIC_CHIPS.map((chip) => (
                            <button
                                key={chip}
                                type="button"
                                className={`btn btn-outline-purple500 btn-small btn-fit  ${topic === chip ? "btn-purple500" : "btn-outline-purple500"}`}
                                onClick={() => setTopic((current) => (current === chip ? "" : chip))}
                            >
                                {chip}
                            </button>
                        ))}
                    </div>
                </section>
            )}

            <section className="section-group">
                <div className="section-group__header">
                    <h3>언제 수업을 진행할까요?</h3>
                </div>
                <div className="calendar-box">
                    <Calendar
                        className="buccl-calendar"
                        locale="ko-KR"
                        calendarType="gregory"
                        prevLabel="〈"
                        nextLabel="〉"
                        prev2Label={null}
                        next2Label={null}
                        formatDay={(locale, date) => String(date.getDate())}
                        showNeighboringMonth={false}
                        value={selectedDate.toDate()}
                        onChange={(date) => setRequestedDate(dayjs(date).format("YYYY-MM-DD"))}
                        tileClassName={({ date, view }) => {
                            if (view !== "month") return "";
                            const classes = ["tile"];
                            const day = date.getDay();
                            if (day === 0) classes.push("sun");
                            if (day === 6) classes.push("sat");
                            return classes.join(" ");
                        }}
                    />
                </div>
            </section>

            <section className="section-group">
                <div className="section-group__header">
                    <h3>몇시에 수업을 진행할까요?</h3>
                </div>
                {/* <div className="lr-tabs">
                    {timeSlotGroups.map((group) => (
                        <button
                            type="button"
                            key={group.label}
                            className={`btn ${selectedTimeGroup === group.label ? "btn-purple500" : "btn-outline-gray200"}`}
                            onClick={() => {
                                setTimeGroup(group.label);
                                if (!group.times.includes(startTime)) setStartTime(group.times[0]);
                            }}
                        >
                            {group.label}
                        </button>
                    ))}
                </div> */}
                {timePeriods.map((period) => (
                    <div key={period.label} className="time-period">
                        <p className="time-period__label">{period.label}</p>
                        <div className="time-slots-grid">
                            {period.times.map((time) => (
                                <button
                                    key={time}
                                    type="button"
                                    className={`btn ${startTime === time ? "btn-purple500 " : "btn-outline-gray200 "}`}
                                    onClick={() => setStartTime(time)}
                                >
                                    {time}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
                {/* <p className="lr-selected-time">선택한 시간 <strong style={{ color: accentColor }}>{startTime}</strong></p> */}
            </section>
        </div>
    );
}
